<template>
  <div class="additional detail-table">
    <div class="additional-heading detail-heading">
      {{ cpLang('jd.additional') }}
    </div>
    <hr>
    <div class="row">
      <div class="col-12 col-md-5">
        <template v-for="item in additional">
          <div v-if="item.value && item.table=='left'" :key="item.key" class="additional-item detail-item">
            <div v-if="item.key !== 'Published On'">
              <b>{{ item.key }}</b>
            </div>
            <div v-if="item.key !== 'Published On'">
              <div v-if="typeof(item.value) === 'object'">
                <span v-if="checkLang(item.value)">
                  {{ item.value.default }}
                </span>
                <template v-else>
                  <MultipleItem :item="item.value" />
                </template>
              </div>
              <span v-else>
                {{ item.value }}
              </span>
            </div>
            <div v-else>
              <div><b>{{ cpLang('jd.pd') }}</b></div>
              <span>{{ formatDate(jobPulishDate) }}</span>
            </div>
          </div>
        </template>
      </div>
      <div class="col-12 col-md-7">
        <template v-for="item in additional">
          <div v-if="item.value && item.table=='right'" :key="item.key" class="additional-item detail-item">
            <div>
              <b>{{ item.key }}</b>
            </div>
            <div v-if="typeof(item.value) === 'object'">
              <span v-if="checkLang(item.value)">
                {{ item.value.default }}
              </span>
              <template v-else>
                <MultipleItem :item="item.value" />
              </template>
            </div>
            <span v-else>
              {{ item.value }}
            </span>
          </div>
        </template>
        <template v-if="shiftType !== null">
          <div v-if="!shiftType.isempty">
            <b>{{ shiftType.key }}</b>
            <div>
              <span v-for="(i, idx) in shiftType.value" :key="`sh-t-${idx}`">
                {{ i.default }}
              </span>
            </div>
          </div>
        </template>
      </div>
      <div class="col-12 row">
        <div class="col-12 col-md-5">
          <div v-if="industrydesc" class="indistry-tag additional-item detail-item">
            <div><b>{{ cpLang('global.industry') }}</b></div>
            <a :href="`/industry/${getSlugLink(industrydesc.en)}-jobs/1`" target="_blank">
              <span class="additional_tag">
                {{ industrydesc.default }}
              </span>
            </a>
          </div>
        </div>
        <div class="col-12 col-md-7">
          <div class="jobFunction-tag additional-item detail-item">
            <div><b>{{ cpLang('global.job_function') }}</b></div>
            <JobFunctionTree :field="field" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MultipleItem from './MultipleItem'
import JobFunctionTree from './JobFunctionTree'
import commonHelper from '~/assets/js/commonHelper.js'

export default {
  components: {
    MultipleItem,
    JobFunctionTree
  },
  props: {
      additional: { //eslint-disable-line
      default: null
    },
    industry: {
      default: null,
      type: String
    },
    industrydesc: {
      default: null,
      type: Object
    },
    // cluster: {
    //   default: null,
    //   type: Number
    // },
    // clusterdesc: {
    //   default: null,
    //   type: Object
    // },
    field: {
      default: null,
      type: [Array, Object]
    },
    jobPulishDate: {
      default: null,
      type: Number
    },
    shiftType: {
      default: null,
      type: Object
    }
  },
  methods: {
    formatDate(date) {
      return commonHelper.formatDate(date)
    },
    getSlugLink(title) {
      const slug = commonHelper.getSlug(title)
      return slug
      // return String(slug).slice(0, -1)
    },
    checkLang(item) {
      return Object.prototype.hasOwnProperty.call(item, 'en')
    }
  }
}

</script>
